/**
 * @fileoverview GET handler for the "/dashboard/conversion_attribution_dashboard/:app_group_id/campaign_canvas_metadata" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { dashboardConversionAttributionDashboardAppGroupIdCampaignCanvasMetadata } from "./constants";
import type { DashboardConversionAttributionDashboardAppGroupIdCampaignCanvasMetadataResult } from "./types";

export const getDashboardConversionAttributionDashboardAppGroupIdCampaignCanvasMetadata = reactQueryFetcherAdapter(
  dashboardConversionAttributionDashboardAppGroupIdCampaignCanvasMetadata,
  (
    signal: AbortSignal,
    appGroupId: string,
    reportId: string
  ): Promise<DashboardConversionAttributionDashboardAppGroupIdCampaignCanvasMetadataResult> => {
    return fetch(
      `/dashboard/conversion_attribution_dashboard/${appGroupId}/campaign_canvas_metadata`,
      "GET",
      { report_id: reportId },
      { signal }
    );
  }
);
